/**
 * Truncate a string to end with ellipsis
 * @param value String to be truncated
 * @param length Final length of the string (endingCharacters inclusive)
 * @example truncate("Hello World!", 6); // Hello…
 */
export const truncate = (value: string, length: number = 100, endingCharacter: string = ''): string =>
  value.length + endingCharacter.length > length
    ? `${value.slice(0, length - endingCharacter.length)}${endingCharacter}`
    : value;
